import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  Typography,
  Box,
} from "@mui/material";
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import CloseIcon from "@mui/icons-material/Close";
import {
  button_bg_color_for_New_Project,
  settingsModal_bg_color_dm,
  uploadFiles_button_default_bg_color,
  uploadFiles_button_hovered_bg_color,
} from "../../../constants/colors";
import CommonToast from "../../Common_Components/CommonToast";
import chatgptlogo from "../../../assets/LLM_Modal_Logo/chatgpt-logo.png";
import anthropiclogo from "../../../assets/LLM_Modal_Logo/anthropic.svg";
import googlelogo from "../../../assets/LLM_Modal_Logo/gemini-color.png";
import xailogo from "../../../assets/LLM_Modal_Logo/grok.png";
import qwenlogo from "../../../assets/LLM_Modal_Logo/qwen-color.png";
import moonshotailogo from "../../../assets/LLM_Modal_Logo/kimi-color.png";
import ai21logo from "../../../assets/LLM_Modal_Logo/ai21.png";
import llamalogo from "../../../assets/LLM_Modal_Logo/llama.png";
import mistralrainbowlogo from "../../../assets/LLM_Modal_Logo/m-rainbow.png";
import deepseeklogo from "../../../assets/LLM_Modal_Logo/deepseek-color.svg";
import nousresearchlogo from "../../../assets/LLM_Modal_Logo/nousresearch.svg";
import novalogo from "../../../assets/LLM_Modal_Logo/nova-color.svg";
// import anthropiclogo from "../../../assets/LLM_Modal_Logo/Anthropic.svg";


const ModalForSelectLLMModal = ({ showLLMModal, setShowLLMModal }) => {
  const { 
    // setSelectedLLMModal, 
    // selectedLLMModal,
    selectedProvider,
    setSelectedProvider,
    selectedModel,
    setSelectedModel 
  } = useWorkspace();

  const [selectedModalLocal, setSelectedModalLocal] = useState(selectedModel);
  const [selectedProviderLocal, setSelectedProviderLocal] = useState(selectedProvider);
  const [selectedModelLocal, setSelectedModelLocal] = useState(selectedModel);
  // const [selectedModalLabelLocal, setSelectedModalLabelLocal] = useState("GPT-4O-MINI");
  const [llmModalSaved, setLLMModalSaved] = useState(false);


  // Comprehensive OpenRouter models from API list
  const modals = [


    // testing models
    { label: "GPT-4O-MINI", value: "gpt-4o-mini", provider: "openai", title1: "OpenAI's multimodal flagship (text, image, audio)", src: chatgptlogo},
    { label: "GPT-4O", value: "gpt-4o", provider: "openai", title1: "OpenAI's multimodal flagship (text, image, audio)", src: chatgptlogo},

    // Top-Tier Latest Anthropic Models
    { label: "Claude Opus 4.1", value: "anthropic/claude-opus-4.1", provider: "openrouter", title1: "Latest Claude Opus with improved reasoning", src: anthropiclogo},
    { label: "Claude Opus 4", value: "anthropic/claude-opus-4", provider: "openrouter", title1: "Advanced Claude Opus model", src: anthropiclogo },
    { label: "Claude Sonnet 4", value: "anthropic/claude-sonnet-4", provider: "openrouter", title1: "Latest Claude Sonnet model", src: anthropiclogo },
    { label: "Claude 3.7 Sonnet", value: "anthropic/claude-3.7-sonnet", provider: "openrouter", title1: "Enhanced Claude 3.7 Sonnet", src: anthropiclogo },
    { label: "Claude 3.7 Sonnet Thinking", value: "anthropic/claude-3.7-sonnet:thinking", provider: "openrouter", title1: "Claude 3.7 with advanced reasoning mode", src: anthropiclogo },
    


    // Popular Anthropic Models
      { label: "Claude 3.5 Sonnet", value: "anthropic/claude-3.5-sonnet", provider: "openrouter", title1: "Balanced performance and capabilities", src: anthropiclogo },
    { label: "Claude 3.5 Sonnet (June)", value: "anthropic/claude-3.5-sonnet-20240620", provider: "openrouter", title1: "June 2024 version of Claude 3.5 Sonnet", src: anthropiclogo },
    { label: "Claude 3.5 Haiku", value: "anthropic/claude-3.5-haiku", provider: "openrouter", title1: "Fast and efficient Claude 3.5 model", src: anthropiclogo },
    { label: "Claude 3.5 Haiku (Oct)", value: "anthropic/claude-3.5-haiku-20241022", provider: "openrouter", title1: "October 2024 Claude 3.5 Haiku", src: anthropiclogo },
    { label: "Claude 3 Opus", value: "anthropic/claude-3-opus", provider: "openrouter", title1: "Most powerful Claude 3 model", src: anthropiclogo },
    { label: "Claude 3 Haiku", value: "anthropic/claude-3-haiku", provider: "openrouter", title1: "Fast and efficient Claude 3 model", src: anthropiclogo },
    { label: "Claude Instant", value: "anthropic/claude-instant-v1", provider: "openrouter", title1: "Fast and affordable Claude model", src: anthropiclogo },
    
    // OpenAI Models
    { label: "GPT-5 Chat", value: "openai/gpt-5-chat", provider: "openrouter", title1: "OpenAI's latest GPT-5 chat model", src: chatgptlogo },
    { label: "GPT-5", value: "openai/gpt-5", provider: "openrouter", title1: "OpenAI's flagship GPT-5 model", src: chatgptlogo },
    { label: "GPT-5 Mini", value: "openai/gpt-5-mini", provider: "openrouter", title1: "Smaller, faster GPT-5 variant", src: chatgptlogo },
    { label: "GPT-5 Nano", value: "openai/gpt-5-nano", provider: "openrouter", title1: "Ultra-lightweight GPT-5 model", src: chatgptlogo },
    { label: "GPT-4O Audio Preview", value: "openai/gpt-4o-audio-preview", provider: "openrouter", title1: "GPT-4O with audio capabilities", src: chatgptlogo },
    { label: "GPT OSS 120B", value: "openai/gpt-oss-120b", provider: "openrouter", title1: "Open-source GPT 120B model", src: chatgptlogo },
    { label: "GPT OSS 120B (Free)", value: "openai/gpt-oss-120b:free", provider: "openrouter", title1: "Free access to GPT OSS 120B", src: chatgptlogo },
    { label: "GPT OSS 20B", value: "openai/gpt-oss-20b", provider: "openrouter", title1: "Open-source GPT 20B model", src: chatgptlogo },
    { label: "GPT OSS 20B (Free)", value: "openai/gpt-oss-20b:free", provider: "openrouter", title1: "Free access to GPT OSS 20B", src: chatgptlogo },
    { label: "O3 Pro", value: "openai/o3-pro", provider: "openrouter", title1: "OpenAI's O3 Pro reasoning model", src: chatgptlogo },
    { label: "Codex Mini", value: "openai/codex-mini", provider: "openrouter", title1: "Compact coding-focused model", src: chatgptlogo },
    { label: "GPT-4 32K", value: "openai/gpt-4-32k", provider: "openrouter", title1: "GPT-4 with extended 32K context window", src: chatgptlogo },
    { label: "GPT-3.5 Turbo", value: "openai/gpt-3.5-turbo", provider: "openrouter", title1: "Fast and cost-effective GPT model", src: chatgptlogo },
    
    // Meta/Llama Models
    { label: "Llama 3 70B", value: "meta-llama/llama-3-70b-instruct", provider: "openrouter", title1: "Meta's powerful Llama 3 70B model", src: llamalogo },
    { label: "Llama 3.1 8B", value: "meta-llama/llama-3.1-8b-instruct", provider: "openrouter", title1: "Efficient Llama 3.1 8B instruction model", src: llamalogo },
    { label: "Llama 3.3 8B (Free)", value: "meta-llama/llama-3.3-8b-instruct:free", provider: "openrouter", title1: "Free access to Llama 3.3 8B", src: llamalogo },
    { label: "Llama 4 Maverick (Free)", value: "meta-llama/llama-4-maverick:free", provider: "openrouter", title1: "Free access to Llama 4 Maverick", src: llamalogo },
    
    // Mistral & Mixtral Models
    { label: "Mistral Medium 3.1", value: "mistralai/mistral-medium-3.1", provider: "openrouter", title1: "Latest Mistral medium model", src: mistralrainbowlogo },
    { label: "Mistral Medium 3", value: "mistralai/mistral-medium-3", provider: "openrouter", title1: "Mistral's medium-sized model v3", src: mistralrainbowlogo },
    { label: "Mistral Small 3.2 24B", value: "mistralai/mistral-small-3.2-24b-instruct", provider: "openrouter", title1: "Mistral's small 24B model", src: mistralrainbowlogo },
    { label: "Mistral Small 3.2 24B (Free)", value: "mistralai/mistral-small-3.2-24b-instruct:free", provider: "openrouter", title1: "Free access to Mistral Small 3.2", src: mistralrainbowlogo },
    { label: "Magistral Medium 2506", value: "mistralai/magistral-medium-2506", provider: "openrouter", title1: "Mistral's Magistral medium model", src: mistralrainbowlogo },
    { label: "Magistral Medium Thinking", value: "mistralai/magistral-medium-2506:thinking", provider: "openrouter", title1: "Magistral with reasoning mode", src: mistralrainbowlogo },
    { label: "Magistral Small 2506", value: "mistralai/magistral-small-2506", provider: "openrouter", title1: "Mistral's Magistral small model", src: mistralrainbowlogo },
    { label: "Codestral 2508", value: "mistralai/codestral-2508", provider: "openrouter", title1: "Latest Mistral coding model", src: mistralrainbowlogo },
    { label: "Devstral Medium", value: "mistralai/devstral-medium", provider: "openrouter", title1: "Mistral's development-focused medium model", src: mistralrainbowlogo },
    { label: "Devstral Small", value: "mistralai/devstral-small", provider: "openrouter", title1: "Mistral's development-focused small model", src: mistralrainbowlogo },
    { label: "Devstral Small 2505", value: "mistralai/devstral-small-2505", provider: "openrouter", title1: "Devstral Small May 2025 version", src: mistralrainbowlogo },
    { label: "Devstral Small 2505 (Free)", value: "mistralai/devstral-small-2505:free", provider: "openrouter", title1: "Free Devstral Small 2505", src: mistralrainbowlogo },
    { label: "Mixtral 8x7B", value: "mistralai/mixtral-8x7b-instruct", provider: "openrouter", title1: "Mistral's mixture of experts model", src: mistralrainbowlogo },
    
    // Google Models
    { label: "Gemini 2.5 Pro", value: "google/gemini-2.5-pro", provider: "openrouter", title1: "Google's latest Gemini 2.5 Pro", src: googlelogo },
    { label: "Gemini 2.5 Pro Preview", value: "google/gemini-2.5-pro-preview", provider: "openrouter", title1: "Preview of Gemini 2.5 Pro", src: googlelogo },
    { label: "Gemini 2.5 Flash", value: "google/gemini-2.5-flash", provider: "openrouter", title1: "Fast Gemini 2.5 Flash model", src: googlelogo },
    { label: "Gemini 2.5 Flash Lite", value: "google/gemini-2.5-flash-lite", provider: "openrouter", title1: "Lightweight Gemini 2.5 Flash", src: googlelogo },
    { label: "Gemini 2.5 Flash Image Preview", value: "google/gemini-2.5-flash-image-preview", provider: "openrouter", title1: "Gemini 2.5 with image preview", src: googlelogo },

    // xAI Models
    { label: "Grok 4", value: "x-ai/grok-4", provider: "openrouter", title1: "xAI's advanced Grok 4 model", src: xailogo },
    { label: "Grok 3", value: "x-ai/grok-3", provider: "openrouter", title1: "xAI's Grok 3 reasoning model", src: xailogo },
    { label: "Grok 3 Mini", value: "x-ai/grok-3-mini", provider: "openrouter", title1: "Compact Grok 3 model", src: xailogo },
    { label: "Grok Code Fast 1", value: "x-ai/grok-code-fast-1", provider: "openrouter", title1: "Fast coding-focused Grok model", src: xailogo },

    // DeepSeek Models
    { label: "DeepSeek V3.1", value: "deepseek/deepseek-chat-v3.1", provider: "openrouter", title1: "Advanced DeepSeek reasoning model", src: deepseeklogo },
    { label: "DeepSeek V3.1 (Free)", value: "deepseek/deepseek-chat-v3.1:free", provider: "openrouter", title1: "Free access to DeepSeek V3.1", src: deepseeklogo },
    { label: "DeepSeek V3.1 Base", value: "deepseek/deepseek-v3.1-base", provider: "openrouter", title1: "DeepSeek V3.1 base model", src: deepseeklogo },
    { label: "DeepSeek R1 0528", value: "deepseek/deepseek-r1-0528", provider: "openrouter", title1: "DeepSeek R1 reasoning model", src: deepseeklogo },
    { label: "DeepSeek R1 0528 (Free)", value: "deepseek/deepseek-r1-0528:free", provider: "openrouter", title1: "Free DeepSeek R1 reasoning", src: deepseeklogo },

    // Qwen Models
    { label: "Qwen3 Max", value: "qwen/qwen3-max", provider: "openrouter", title1: "Qwen's flagship model", src: qwenlogo },
    { label: "Qwen Coder", value: "qwen/qwen-coder", provider: "openrouter", title1: "Qwen model specialized for coding", src: qwenlogo },
    { label: "Qwen Coder (Free)", value: "qwen/qwen3-coder:free", provider: "openrouter", title1: "Free Qwen coding model", src: qwenlogo },
    { label: "Qwen3 30B Thinking", value: "qwen/qwen3-30b-a3b-thinking-2507", provider: "openrouter", title1: "Qwen3 30B with thinking capabilities", src: qwenlogo },

    // MoonshotAI Models  
    { label: "Kimi K2", value: "moonshotai/kimi-k2", provider: "openrouter", title1: "MoonshotAI's Kimi K2 model", src: moonshotailogo },
    { label: "Kimi K2 (Free)", value: "moonshotai/kimi-k2:free", provider: "openrouter", title1: "Free access to Kimi K2", src: moonshotailogo },
    { label: "Kimi Dev 72B", value: "moonshotai/kimi-dev-72b", provider: "openrouter", title1: "Kimi development-focused 72B model", src: moonshotailogo },
    { label: "Kimi Dev 72B (Free)", value: "moonshotai/kimi-dev-72b:free", provider: "openrouter", title1: "Free Kimi Dev 72B", src: moonshotailogo },
    { label: "Kimi VL A3B Thinking (Free)", value: "moonshotai/kimi-vl-a3b-thinking:free", provider: "openrouter", title1: "Free vision-language model with thinking", src: moonshotailogo },

    // NousResearch Models
    { label: "Hermes 4 405B", value: "nousresearch/hermes-4-405b", provider: "openrouter", title1: "Latest Hermes 4 405B model", src: nousresearchlogo },
    { label: "Hermes 4 70B", value: "nousresearch/hermes-4-70b", provider: "openrouter", title1: "Hermes 4 70B reasoning model", src: nousresearchlogo },
    { label: "Hermes 3 Llama 405B", value: "nousresearch/hermes-3-llama-3.1-405b", provider: "openrouter", title1: "Advanced Hermes 3 on Llama base", src: nousresearchlogo },
    
    // AI21 Jamba Models
    { label: "Jamba Large 1.7", value: "ai21/jamba-large-1.7", provider: "openrouter", title1: "AI21's large Jamba model", src: ai21logo },
    { label: "Jamba Mini 1.7", value: "ai21/jamba-mini-1.7", provider: "openrouter", title1: "AI21's compact Jamba model", src: ai21logo },
    
    // Amazon Nova Models
    { label: "Nova Pro V1", value: "amazon/nova-pro-v1", provider: "openrouter", title1: "Amazon's Nova Pro model", src: novalogo },
    { label: "Nova Lite V1", value: "amazon/nova-lite-v1", provider: "openrouter", title1: "Amazon's lightweight Nova model", src: novalogo },
    { label: "Nova Micro V1", value: "amazon/nova-micro-v1", provider: "openrouter", title1: "Amazon's micro Nova model", src: novalogo },
    
    // Agentica & DeepCoder Models
    { label: "DeepCoder 14B", value: "agentica-org/deepcoder-14b-preview", provider: "openrouter", title1: "Advanced coding model by Agentica", src: chatgptlogo },
    { label: "DeepCoder 14B (Free)", value: "agentica-org/deepcoder-14b-preview:free", provider: "openrouter", title1: "Free access to DeepCoder 14B", src: chatgptlogo },

    // Additional Specialized Models
    { label: "Goliath 120B", value: "alpindale/goliath-120b", provider: "openrouter", title1: "Large-scale Goliath model", src: chatgptlogo },
    { label: "Magnum V4 72B", value: "anthracite-org/magnum-v4-72b", provider: "openrouter", title1: "Anthracite's Magnum V4 model", src: chatgptlogo },
    { label: "Maestro Reasoning", value: "arcee-ai/maestro-reasoning", provider: "openrouter", title1: "Arcee AI's reasoning-focused model", src: chatgptlogo },
  ];


  const theme = localStorage.getItem("theme");

  const handleClose = () => {
    setShowLLMModal(false);
    setSelectedModalLocal(selectedModel);
    setSelectedProviderLocal(selectedProvider);
    setSelectedModelLocal(selectedModel);
    // setSelectedModalLabelLocal(selectedModalLabel)
  };

  const handleSave = () => {
    setSelectedModel(selectedModalLocal);
    setSelectedProvider(selectedProviderLocal);
    setSelectedModel(selectedModelLocal);
    setShowLLMModal(false);
    // setSelectedModalLabel(selectedModalLabelLocal);
    
    // Save to localStorage for persistence
    localStorage.setItem('selectedProvider', selectedProviderLocal);
    localStorage.setItem('selectedModel', selectedModelLocal);
    // localStorage.setItem('selectedModalLabel', selectedModalLabelLocal);
  };

  const handleSelectModal = (modal) => {
    setSelectedModalLocal(modal?.value);
    setSelectedProviderLocal(modal?.provider);
    setSelectedModelLocal(modal?.value);
    // setSelectedModalLabelLocal(modal?.label);
  };

  const handleCloseToast = () => {
    setLLMModalSaved(false);
  };

  return (
    <>
      <CommonToast
        open={llmModalSaved}
        onClose={handleCloseToast}
        content="OpenRouter AI Model saved"
        bgColor="#282D51"
        fontColor="#fff"
        fontSize="14px"
        fontWeight="500"
        autoHideDuration={3000}
        iconType="success"
      />
      <Dialog
        open={showLLMModal}
        onClose={handleClose}
        maxWidth="md" // increase maxWidth
        PaperProps={{
          style: {
            width: "auto", // Fixed width
            height: "636px", // Fixed height
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor:
              theme === "dark" ? settingsModal_bg_color_dm : "#fff",
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle
          style={{
            fontSize: "20px",
            fontWeight: "600",
            color: theme === "dark" ? "#FFFFFF" : "",
            position: "relative",
            display: "flex",
            justifyContent: "space-between",
            alignContent: "center",
          }}
        >
          Select OpenRouter AI Model
          <span
            style={{
              content: '""',
              position: "absolute",
              bottom: 0,
              left: 0,
              width: "100%",
              height: "1px",
              backgroundColor: "#FFFFFF",
              opacity: 0.2, // Set the opacity for the border
            }}
          ></span>
          <Box
            onClick={handleClose}
            sx={{
              cursor: "pointer",
            }}
          >
            <CloseIcon />
          </Box>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            alignSelf: "center",
            maxHeight: "calc(100vh - 200px)",
            overflowY: "auto",
            backgroundColor: theme === "light" ? "#dee2e6" : "",
            p: 2,
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <FormControl component="fieldset">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "28px", // Space between items,
                justifyContent: "center",
              }}
            >
              {modals.map((modal, index) => (
                <div key={index}>
                  <div
                    onClick={() => handleSelectModal(modal)}
                    style={{
                      // marginBottom: '12px',
                      textAlign: "center",
                      cursor: "pointer",
                      border:
                        selectedModalLocal === modal?.value
                          ? "1px solid #ffffff"
                          : "none",
                      borderRadius: "10px",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      columnGap: "16px",
                    }}
                  >
                    <img
                      src={modal?.src}
                      alt={modal?.label}
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "6px",
                        objectFit: "contain",
                        backgroundColor: "#f8f9fa",
                        padding: "4px",
                      }}
                    />

                    <div
                      style={{
                        textAlign: "start",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                      }}
                    >
                      <Typography variant="body1" sx={{ color: "#FFFFFF" }}>
                        {modal?.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontSize: "16px",
                          fontWeight: 400,
                          color: "#FFFFFF",
                          marginBottom: "-12px",
                        }}
                      >
                        {modal.title1}
                      </Typography>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              mt: 2,
              pt: 2,
              position: "relative",
              width: "100%",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "1px",
                backgroundColor: theme === "dark" ? "#FFFFFF" : "#ccc",
                opacity: 0.2, // Set the opacity for the border
              },
            }}
          >
            <Button
              onClick={handleClose}
              sx={{
                mr: 1,
                backgroundColor:
                  theme === "dark" ? uploadFiles_button_default_bg_color : "",
                "&:hover": {
                  backgroundColor: uploadFiles_button_hovered_bg_color,
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
              }}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor:
                  theme === "dark" ? button_bg_color_for_New_Project : "",
                "&:hover": {
                  backgroundColor: "#FFD9AA",
                },
                color: "#17182C",
                fontSize: "16px",
                fontWeight: "600",
                textTransform: "none",
              }}
            >
              Save
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalForSelectLLMModal;
